/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import { sha256 } from 'js-sha256';

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)

// Ant Vue
import {Affix,
  Anchor,
  AutoComplete,
  Alert,
  Avatar,
  BackTop,
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Collapse,
  Comment,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Dropdown,
  Empty,
  Form,
  FormModel,
  Icon,
  Input,
  InputNumber,
  Layout,
  List,
  LocaleProvider,
  message,
  Menu,
  Mentions,
  Modal,
  notification,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Rate,
  Row,
  Select,
  Slider,
  Spin,
  Statistic,
  Steps,
  Switch,
  Table,
  Transfer,
  Tree,
  TreeSelect,
  Tabs,
  Tag,
  TimePicker,
  Timeline,
  Tooltip,
  Upload,
  Drawer,
  Skeleton,
  Result,
  Descriptions,
  PageHeader} from 'ant-design-vue'

Vue.use(Layout)
Vue.use(Affix)
Vue.use(Anchor)
Vue.use(AutoComplete)
Vue.use(BackTop)
Vue.use(Badge)
Vue.use(Breadcrumb)
Vue.use(Calendar)
Vue.use(Card)
Vue.use(Comment)
Vue.use(Carousel)
Vue.use(Cascader)
Vue.use(Checkbox)
Vue.use(Col)
Vue.use(ConfigProvider)
Vue.use(DatePicker)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Rate)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(Mentions)
Vue.use(Menu)
Vue.use(LocaleProvider)
Vue.use(List)
Vue.use(PageHeader)
Vue.use(Descriptions)
Vue.use(Result)
Vue.use(Drawer)
Vue.use(Timeline)
Vue.use(Tag)
Vue.use(TreeSelect)
Vue.use(Tree)
Vue.use(Transfer)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(Statistic)
Vue.use(Row)
Vue.use(Slider)
Vue.use(Upload)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(Table)
Vue.use(Button)
Vue.use(Modal)
Vue.use(InputNumber)
Vue.use(Alert)
Vue.use(Spin)
Vue.use(Popconfirm)
Vue.use(Icon)
Vue.use(message)
Vue.use(Dropdown)
Vue.use(Progress)
Vue.use(Select)
Vue.use(Skeleton)
Vue.use(Avatar)
Vue.use(TimePicker)
Vue.use(Tabs)
Vue.use(Tooltip)
Vue.use(Collapse)
Vue.use(notification)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.prototype.$warning = Modal.warning
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$notification = notification
Vue.prototype.$message = message

notification.config({ 
  placement: 'topRight',
  top: '100px',
  duration: 3,
})

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});

Vue.component(vSelect)

let Tawk_API = {}

window.Tawk_API=Tawk_API;
  (async function(){
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='https://embed.tawk.to/60bbb4a0dd60a20abbe4c36e/1f7ejj5a9';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
  })();

export function changeTawkUser(userInfo) {
  window.Tawk_API.onLoad = function () {
    Tawk_API.setAttributes({
      name: `${userInfo.name}`,
      email: userInfo.email,
      hash: sha256.hmac('25d14149cf0183e2a2c4ee0fa36916c224f5bab1', userInfo.email),
    }, function(error){});
  }
}

export function changeTawkCompany(userInfo, companyId) {
  console.log(userInfo.name, companyId)

  Tawk_API.setAttributes({
    name: `${userInfo.name} (${companyId})`,
    email: userInfo.email,
    hash: sha256.hmac('25d14149cf0183e2a2c4ee0fa36916c224f5bab1', userInfo.email),
  }, function(error){});
}

export function addTawkEvent(eventName) {
  Tawk_API.addEvent('product-add-to-cart', { name: eventName }, function(error){console.log(error)});
}